export enum WebinarRegistrationFieldType {
    Email = 'email',
    FirstName = 'firstName',
    LastName = 'lastName',
    MiddleName = 'middleName',
    Phone = 'phone',
    Birthday = 'birthday',
    Gender = 'gender',
    TermOfService = 'termsOfService'
}